import { render, staticRenderFns } from "./ModalMensajeGeneral.vue?vue&type=template&id=db2c013e&scoped=true"
import script from "./ModalMensajeGeneral.vue?vue&type=script&lang=js"
export * from "./ModalMensajeGeneral.vue?vue&type=script&lang=js"
import style0 from "./ModalMensajeGeneral.vue?vue&type=style&index=0&id=db2c013e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2c013e",
  null
  
)

export default component.exports